var map = {
	"./img_1.jpg": 26083,
	"./img_2.png": 32362,
	"./img_3.jpg": 54936,
	"./img_4.jpg": 88896,
	"./img_5.jpg": 40381,
	"./img_6.jpg": 14271,
	"./img_7.jpg": 42352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60844;